const CorrosionData = [
    {
      id: 1,
      title: "Cathodic Protection Systems",
      description:
        "We design, install, and maintain cathodic protection systems to prevent corrosion in underground and submerged structures, including pipelines, storage tanks, and marine assets.",
    },
    {
      id: 2,
      title: "Coating & Linings Solutions",
      description:
        "Our high-performance protective coatings and linings shield surfaces from environmental and chemical exposure, extending the lifespan of assets in harsh conditions.",
    },
    {
      id: 3,
      title: "Corrosion Risk Assessment & Monitoring",
      description:
        "We conduct real-time corrosion risk assessments, implementing advanced monitoring techniques to identify and mitigate potential threats before they escalate.",
    },
    {
      id: 4,
      title: "Pipeline Integrity Management",
      description:
        "Through internal corrosion control, chemical treatment, and smart pigging, we ensure pipelines remain structurally sound and compliant with safety regulations.",
    },
    {
      id: 5,
      title: "Non-Destructive Testing (NDT) & Inspection",
      description:
        "We use ultrasonic testing, radiographic inspection, and magnetic particle testing to detect early signs of corrosion and material degradation.",
    },
    {
      id: 6,
      title: "Corrosion Inhibitor Application",
      description:
        "Our customized corrosion inhibitors help slow down degradation in pipelines, vessels, and industrial systems, optimizing their efficiency and lifespan.",
    },
  ];
  
  export default CorrosionData;
  